/* Generated by analysis/jeremias-set-4m-pilot/build-cart-mapping.mjs. Contains validated 4 m + 5 m + 6 m + 7 m Jeremias sets. */
(function jeremiasSetToBomCart(root) {
  'use strict';

  const specifications = Object.freeze({
  "62056390328588": {
    "candidateId": "DW-FU-DN130-H5985-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-fu",
    "dn": 130,
    "setSku": "JER-SET-DWFU-6M-DN130-W100",
    "setPriceCents": 137570,
    "bom": [
      {
        "sku": "DW05130",
        "variantId": "62036863156492",
        "quantity": 1
      },
      {
        "sku": "DW10130",
        "variantId": "62036868530444",
        "quantity": 1
      },
      {
        "sku": "DW317130",
        "variantId": "62036894581004",
        "quantity": 1
      },
      {
        "sku": "DW32130",
        "variantId": "62036895629580",
        "quantity": 1
      },
      {
        "sku": "DW31130",
        "variantId": "62036895105292",
        "quantity": 1
      },
      {
        "sku": "DW13130",
        "variantId": "62036871053580",
        "quantity": 5
      },
      {
        "sku": "DW22130",
        "variantId": "62036880064780",
        "quantity": 2
      },
      {
        "sku": "DW01130",
        "variantId": "62036861059340",
        "quantity": 1
      }
    ]
  },
  "62056390361356": {
    "candidateId": "DW-FU-DN150-H5985-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-fu",
    "dn": 150,
    "setSku": "JER-SET-DWFU-6M-DN150-W100",
    "setPriceCents": 150010,
    "bom": [
      {
        "sku": "DW-JGP01150",
        "variantId": "62047284265228",
        "quantity": 1
      },
      {
        "sku": "DW13150",
        "variantId": "62036871086348",
        "quantity": 5
      },
      {
        "sku": "DW22150",
        "variantId": "62036880097548",
        "quantity": 2
      },
      {
        "sku": "DW01150",
        "variantId": "62036861092108",
        "quantity": 1
      }
    ]
  },
  "62056390394124": {
    "candidateId": "DW-FU-DN180-H5985-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-fu",
    "dn": 180,
    "setSku": "JER-SET-DWFU-6M-DN180-W100",
    "setPriceCents": 167570,
    "bom": [
      {
        "sku": "DW05180",
        "variantId": "62036863254796",
        "quantity": 1
      },
      {
        "sku": "DW10180",
        "variantId": "62036868628748",
        "quantity": 1
      },
      {
        "sku": "DW317180",
        "variantId": "62036894679308",
        "quantity": 1
      },
      {
        "sku": "DW32180",
        "variantId": "62036895727884",
        "quantity": 1
      },
      {
        "sku": "DW31180",
        "variantId": "62036895203596",
        "quantity": 1
      },
      {
        "sku": "DW13180",
        "variantId": "62036871151884",
        "quantity": 5
      },
      {
        "sku": "DW22180",
        "variantId": "62036880163084",
        "quantity": 2
      },
      {
        "sku": "DW01180",
        "variantId": "62036861157644",
        "quantity": 1
      }
    ]
  },
  "62056390426892": {
    "candidateId": "DW-FU-DN200-H5985-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-fu",
    "dn": 200,
    "setSku": "JER-SET-DWFU-6M-DN200-W100",
    "setPriceCents": 188770,
    "bom": [
      {
        "sku": "DW05200",
        "variantId": "62036863287564",
        "quantity": 1
      },
      {
        "sku": "DW10200",
        "variantId": "62036868661516",
        "quantity": 1
      },
      {
        "sku": "DW317200",
        "variantId": "62036894712076",
        "quantity": 1
      },
      {
        "sku": "DW32200",
        "variantId": "62036895760652",
        "quantity": 1
      },
      {
        "sku": "DW31200",
        "variantId": "62036895236364",
        "quantity": 1
      },
      {
        "sku": "DW13200",
        "variantId": "62036871184652",
        "quantity": 5
      },
      {
        "sku": "DW22200",
        "variantId": "62036880195852",
        "quantity": 2
      },
      {
        "sku": "DW01200",
        "variantId": "62036861190412",
        "quantity": 1
      }
    ]
  },
  "62056390459660": {
    "candidateId": "DW-ECO-2-0-DN130-H9-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-eco-2-0",
    "dn": 130,
    "setSku": "JER-SET-DWECO20-6M-DN130-W100",
    "setPriceCents": 137960,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05130",
        "variantId": "62036841169164",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10130",
        "variantId": "62036843921676",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11130",
        "variantId": "62036845166860",
        "quantity": 1
      },
      {
        "sku": "DWECO261130",
        "variantId": "62036934066444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13130",
        "variantId": "62036845953292",
        "quantity": 6
      },
      {
        "sku": "205-DWETN32130",
        "variantId": "62036850114828",
        "quantity": 1
      },
      {
        "sku": "DWECO22130",
        "variantId": "62036929839372",
        "quantity": 2
      }
    ]
  },
  "62056390492428": {
    "candidateId": "DW-ECO-2-0-DN150-H9-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-eco-2-0",
    "dn": 150,
    "setSku": "JER-SET-DWECO20-6M-DN150-W100",
    "setPriceCents": 149160,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05150",
        "variantId": "62036841201932",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10150",
        "variantId": "62036843954444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11150",
        "variantId": "62036845199628",
        "quantity": 1
      },
      {
        "sku": "DWECO261150",
        "variantId": "62036934099212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13150",
        "variantId": "62036845986060",
        "quantity": 6
      },
      {
        "sku": "205-DWETN32150",
        "variantId": "62036850147596",
        "quantity": 1
      },
      {
        "sku": "DWECO22150",
        "variantId": "62036929872140",
        "quantity": 2
      }
    ]
  },
  "62056390525196": {
    "candidateId": "DW-ECO-2-0-DN160-H9-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-eco-2-0",
    "dn": 160,
    "setSku": "JER-SET-DWECO20-6M-DN160-W100",
    "setPriceCents": 157160,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05160",
        "variantId": "62036841234700",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10160",
        "variantId": "62036843987212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11160",
        "variantId": "62036845232396",
        "quantity": 1
      },
      {
        "sku": "DWECO261160",
        "variantId": "62036934131980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13160",
        "variantId": "62036846018828",
        "quantity": 6
      },
      {
        "sku": "205-DWETN32160",
        "variantId": "62036850180364",
        "quantity": 1
      },
      {
        "sku": "DWECO22160",
        "variantId": "62036929904908",
        "quantity": 2
      }
    ]
  },
  "62056390557964": {
    "candidateId": "DW-ECO-2-0-DN180-H9-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-eco-2-0",
    "dn": 180,
    "setSku": "JER-SET-DWECO20-6M-DN180-W100",
    "setPriceCents": 164760,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05180",
        "variantId": "62036841267468",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10180",
        "variantId": "62036844019980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11180",
        "variantId": "62036845265164",
        "quantity": 1
      },
      {
        "sku": "DWECO261180",
        "variantId": "62036934164748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13180",
        "variantId": "62036846051596",
        "quantity": 6
      },
      {
        "sku": "205-DWETN32180",
        "variantId": "62036850213132",
        "quantity": 1
      },
      {
        "sku": "DWECO22180",
        "variantId": "62036929937676",
        "quantity": 2
      }
    ]
  },
  "62056390590732": {
    "candidateId": "DW-ECO-2-0-DN200-H9-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-eco-2-0",
    "dn": 200,
    "setSku": "JER-SET-DWECO20-6M-DN200-W100",
    "setPriceCents": 182560,
    "bom": [
      {
        "sku": "DW392",
        "variantId": "62036905492748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05200",
        "variantId": "62036841300236",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10200",
        "variantId": "62036844052748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11200",
        "variantId": "62036845297932",
        "quantity": 1
      },
      {
        "sku": "DWECO261200",
        "variantId": "62036934197516",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13200",
        "variantId": "62036846084364",
        "quantity": 6
      },
      {
        "sku": "205-DWETN32200",
        "variantId": "62036850245900",
        "quantity": 1
      },
      {
        "sku": "DWECO22200",
        "variantId": "62036929970444",
        "quantity": 2
      }
    ]
  },
  "62056390623500": {
    "candidateId": "DW-BLACK-DN130-H9-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-black",
    "dn": 130,
    "setSku": "JER-SET-DWBLACK-6M-DN130-W100",
    "setPriceCents": 210260,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05130",
        "variantId": "62054703300876",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10130",
        "variantId": "62054704906508",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866130",
        "variantId": "62054705332492",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13130",
        "variantId": "62054705725708",
        "quantity": 6
      },
      {
        "sku": "16-DWECO22130",
        "variantId": "62054706675980",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31130",
        "variantId": "62054707134732",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32130",
        "variantId": "62054707527948",
        "quantity": 1
      }
    ]
  },
  "62056390656268": {
    "candidateId": "DW-BLACK-DN150-H9-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-black",
    "dn": 150,
    "setSku": "JER-SET-DWBLACK-6M-DN150-W100",
    "setPriceCents": 230760,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05150",
        "variantId": "62054703333644",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10150",
        "variantId": "62054704939276",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866150",
        "variantId": "62054705365260",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13150",
        "variantId": "62054705758476",
        "quantity": 6
      },
      {
        "sku": "16-DWECO22150",
        "variantId": "62054706708748",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31150",
        "variantId": "62054707167500",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32150",
        "variantId": "62054707560716",
        "quantity": 1
      }
    ]
  },
  "62056390689036": {
    "candidateId": "DW-BLACK-DN180-H9-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-black",
    "dn": 180,
    "setSku": "JER-SET-DWBLACK-6M-DN180-W100",
    "setPriceCents": 253660,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05180",
        "variantId": "62054703366412",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10180",
        "variantId": "62054704972044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866180",
        "variantId": "62054705398028",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13180",
        "variantId": "62054705791244",
        "quantity": 6
      },
      {
        "sku": "16-DWECO22180",
        "variantId": "62054706741516",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31180",
        "variantId": "62054707200268",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32180",
        "variantId": "62054707593484",
        "quantity": 1
      }
    ]
  },
  "62056390721804": {
    "candidateId": "DW-BLACK-DN200-H9-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-black",
    "dn": 200,
    "setSku": "JER-SET-DWBLACK-6M-DN200-W100",
    "setPriceCents": 280060,
    "bom": [
      {
        "sku": "16-DW392",
        "variantId": "62055212876044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05200",
        "variantId": "62054703399180",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10200",
        "variantId": "62054705004812",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866200",
        "variantId": "62054705430796",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13200",
        "variantId": "62054705824012",
        "quantity": 6
      },
      {
        "sku": "16-DWECO22200",
        "variantId": "62054706774284",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31200",
        "variantId": "62054707233036",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32200",
        "variantId": "62054707626252",
        "quantity": 1
      }
    ]
  },
  "62056390754572": {
    "candidateId": "DW-GREY-DN130-H9-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-grey",
    "dn": 130,
    "setSku": "JER-SET-DWGREY-6M-DN130-W100",
    "setPriceCents": 210260,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05130",
        "variantId": "62054703563020",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10130",
        "variantId": "62054705070348",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866130",
        "variantId": "62054705463564",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13130",
        "variantId": "62054705889548",
        "quantity": 6
      },
      {
        "sku": "28-DWECO22130",
        "variantId": "62054706872588",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31130",
        "variantId": "62054707265804",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32130",
        "variantId": "62054707659020",
        "quantity": 1
      }
    ]
  },
  "62056390787340": {
    "candidateId": "DW-GREY-DN150-H9-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-grey",
    "dn": 150,
    "setSku": "JER-SET-DWGREY-6M-DN150-W100",
    "setPriceCents": 230760,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05150",
        "variantId": "62054703595788",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10150",
        "variantId": "62054705103116",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866150",
        "variantId": "62054705496332",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13150",
        "variantId": "62054705922316",
        "quantity": 6
      },
      {
        "sku": "28-DWECO22150",
        "variantId": "62054706905356",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31150",
        "variantId": "62054707298572",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32150",
        "variantId": "62054707691788",
        "quantity": 1
      }
    ]
  },
  "62056390820108": {
    "candidateId": "DW-GREY-DN180-H9-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-grey",
    "dn": 180,
    "setSku": "JER-SET-DWGREY-6M-DN180-W100",
    "setPriceCents": 253660,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05180",
        "variantId": "62054703628556",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10180",
        "variantId": "62054705135884",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866180",
        "variantId": "62054705529100",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13180",
        "variantId": "62054705955084",
        "quantity": 6
      },
      {
        "sku": "28-DWECO22180",
        "variantId": "62054706938124",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31180",
        "variantId": "62054707331340",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32180",
        "variantId": "62054707724556",
        "quantity": 1
      }
    ]
  },
  "62056390852876": {
    "candidateId": "DW-GREY-DN200-H9-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-grey",
    "dn": 200,
    "setSku": "JER-SET-DWGREY-6M-DN200-W100",
    "setPriceCents": 280060,
    "bom": [
      {
        "sku": "28-DW392",
        "variantId": "62055212908812",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05200",
        "variantId": "62054703661324",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10200",
        "variantId": "62054705168652",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866200",
        "variantId": "62054705561868",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13200",
        "variantId": "62054705987852",
        "quantity": 6
      },
      {
        "sku": "28-DWECO22200",
        "variantId": "62054706970892",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31200",
        "variantId": "62054707364108",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32200",
        "variantId": "62054707757324",
        "quantity": 1
      }
    ]
  },
  "62056390951180": {
    "candidateId": "DW-WHITE-DN130-H9-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-white",
    "dn": 130,
    "setSku": "JER-SET-DWWHITE-6M-DN130-W100",
    "setPriceCents": 210260,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05130",
        "variantId": "62054704709900",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10130",
        "variantId": "62054705201420",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866130",
        "variantId": "62054705594636",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13130",
        "variantId": "62054706053388",
        "quantity": 6
      },
      {
        "sku": "47-DWECO22130",
        "variantId": "62054707003660",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31130",
        "variantId": "62054707396876",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32130",
        "variantId": "62054707790092",
        "quantity": 1
      }
    ]
  },
  "62056390983948": {
    "candidateId": "DW-WHITE-DN150-H9-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-white",
    "dn": 150,
    "setSku": "JER-SET-DWWHITE-6M-DN150-W100",
    "setPriceCents": 230760,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05150",
        "variantId": "62054704742668",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10150",
        "variantId": "62054705234188",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866150",
        "variantId": "62054705627404",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13150",
        "variantId": "62054706086156",
        "quantity": 6
      },
      {
        "sku": "47-DWECO22150",
        "variantId": "62054707036428",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31150",
        "variantId": "62054707429644",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32150",
        "variantId": "62054707822860",
        "quantity": 1
      }
    ]
  },
  "62056391016716": {
    "candidateId": "DW-WHITE-DN180-H9-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-white",
    "dn": 180,
    "setSku": "JER-SET-DWWHITE-6M-DN180-W100",
    "setPriceCents": 253660,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05180",
        "variantId": "62054704775436",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10180",
        "variantId": "62054705266956",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866180",
        "variantId": "62054705660172",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13180",
        "variantId": "62054706118924",
        "quantity": 6
      },
      {
        "sku": "47-DWECO22180",
        "variantId": "62054707069196",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31180",
        "variantId": "62054707462412",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32180",
        "variantId": "62054707855628",
        "quantity": 1
      }
    ]
  },
  "62056391049484": {
    "candidateId": "DW-WHITE-DN200-H9-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 6 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-6-m-jeremias-dw-white",
    "dn": 200,
    "setSku": "JER-SET-DWWHITE-6M-DN200-W100",
    "setPriceCents": 280060,
    "bom": [
      {
        "sku": "47-DW392",
        "variantId": "62055212941580",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05200",
        "variantId": "62054704808204",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10200",
        "variantId": "62054705299724",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866200",
        "variantId": "62054705692940",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13200",
        "variantId": "62054706151692",
        "quantity": 6
      },
      {
        "sku": "47-DWECO22200",
        "variantId": "62054707101964",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31200",
        "variantId": "62054707495180",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32200",
        "variantId": "62054707888396",
        "quantity": 1
      }
    ]
  },
  "62056702869772": {
    "candidateId": "DW-FU-DN130-H6929-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-fu",
    "dn": 130,
    "setSku": "JER-SET-DWFU-7M-DN130-W100",
    "setPriceCents": 150160,
    "bom": [
      {
        "sku": "DW05130",
        "variantId": "62036863156492",
        "quantity": 1
      },
      {
        "sku": "DW10130",
        "variantId": "62036868530444",
        "quantity": 1
      },
      {
        "sku": "DW317130",
        "variantId": "62036894581004",
        "quantity": 1
      },
      {
        "sku": "DW32130",
        "variantId": "62036895629580",
        "quantity": 1
      },
      {
        "sku": "DW31130",
        "variantId": "62036895105292",
        "quantity": 1
      },
      {
        "sku": "DW13130",
        "variantId": "62036871053580",
        "quantity": 6
      },
      {
        "sku": "DW22130",
        "variantId": "62036880064780",
        "quantity": 2
      },
      {
        "sku": "DW01130",
        "variantId": "62036861059340",
        "quantity": 1
      }
    ]
  },
  "62056702902540": {
    "candidateId": "DW-FU-DN150-H6929-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-fu",
    "dn": 150,
    "setSku": "JER-SET-DWFU-7M-DN150-W100",
    "setPriceCents": 164100,
    "bom": [
      {
        "sku": "DW-JGP01150",
        "variantId": "62047284265228",
        "quantity": 1
      },
      {
        "sku": "DW13150",
        "variantId": "62036871086348",
        "quantity": 6
      },
      {
        "sku": "DW22150",
        "variantId": "62036880097548",
        "quantity": 2
      },
      {
        "sku": "DW01150",
        "variantId": "62036861092108",
        "quantity": 1
      }
    ]
  },
  "62056702935308": {
    "candidateId": "DW-FU-DN180-H6929-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-fu",
    "dn": 180,
    "setSku": "JER-SET-DWFU-7M-DN180-W100",
    "setPriceCents": 183460,
    "bom": [
      {
        "sku": "DW05180",
        "variantId": "62036863254796",
        "quantity": 1
      },
      {
        "sku": "DW10180",
        "variantId": "62036868628748",
        "quantity": 1
      },
      {
        "sku": "DW317180",
        "variantId": "62036894679308",
        "quantity": 1
      },
      {
        "sku": "DW32180",
        "variantId": "62036895727884",
        "quantity": 1
      },
      {
        "sku": "DW31180",
        "variantId": "62036895203596",
        "quantity": 1
      },
      {
        "sku": "DW13180",
        "variantId": "62036871151884",
        "quantity": 6
      },
      {
        "sku": "DW22180",
        "variantId": "62036880163084",
        "quantity": 2
      },
      {
        "sku": "DW01180",
        "variantId": "62036861157644",
        "quantity": 1
      }
    ]
  },
  "62056702968076": {
    "candidateId": "DW-FU-DN200-H6929-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-fu",
    "dn": 200,
    "setSku": "JER-SET-DWFU-7M-DN200-W100",
    "setPriceCents": 206460,
    "bom": [
      {
        "sku": "DW05200",
        "variantId": "62036863287564",
        "quantity": 1
      },
      {
        "sku": "DW10200",
        "variantId": "62036868661516",
        "quantity": 1
      },
      {
        "sku": "DW317200",
        "variantId": "62036894712076",
        "quantity": 1
      },
      {
        "sku": "DW32200",
        "variantId": "62036895760652",
        "quantity": 1
      },
      {
        "sku": "DW31200",
        "variantId": "62036895236364",
        "quantity": 1
      },
      {
        "sku": "DW13200",
        "variantId": "62036871184652",
        "quantity": 6
      },
      {
        "sku": "DW22200",
        "variantId": "62036880195852",
        "quantity": 2
      },
      {
        "sku": "DW01200",
        "variantId": "62036861190412",
        "quantity": 1
      }
    ]
  },
  "62056703000844": {
    "candidateId": "DW-ECO-2-0-DN130-H10-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-eco-2-0",
    "dn": 130,
    "setSku": "JER-SET-DWECO20-7M-DN130-W100",
    "setPriceCents": 148450,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05130",
        "variantId": "62036841169164",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10130",
        "variantId": "62036843921676",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11130",
        "variantId": "62036845166860",
        "quantity": 1
      },
      {
        "sku": "DWECO261130",
        "variantId": "62036934066444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13130",
        "variantId": "62036845953292",
        "quantity": 7
      },
      {
        "sku": "205-DWETN32130",
        "variantId": "62036850114828",
        "quantity": 1
      },
      {
        "sku": "DWECO22130",
        "variantId": "62036929839372",
        "quantity": 2
      }
    ]
  },
  "62056703033612": {
    "candidateId": "DW-ECO-2-0-DN150-H10-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-eco-2-0",
    "dn": 150,
    "setSku": "JER-SET-DWECO20-7M-DN150-W100",
    "setPriceCents": 160850,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05150",
        "variantId": "62036841201932",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10150",
        "variantId": "62036843954444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11150",
        "variantId": "62036845199628",
        "quantity": 1
      },
      {
        "sku": "DWECO261150",
        "variantId": "62036934099212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13150",
        "variantId": "62036845986060",
        "quantity": 7
      },
      {
        "sku": "205-DWETN32150",
        "variantId": "62036850147596",
        "quantity": 1
      },
      {
        "sku": "DWECO22150",
        "variantId": "62036929872140",
        "quantity": 2
      }
    ]
  },
  "62056703066380": {
    "candidateId": "DW-ECO-2-0-DN160-H10-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-eco-2-0",
    "dn": 160,
    "setSku": "JER-SET-DWECO20-7M-DN160-W100",
    "setPriceCents": 169750,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05160",
        "variantId": "62036841234700",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10160",
        "variantId": "62036843987212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11160",
        "variantId": "62036845232396",
        "quantity": 1
      },
      {
        "sku": "DWECO261160",
        "variantId": "62036934131980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13160",
        "variantId": "62036846018828",
        "quantity": 7
      },
      {
        "sku": "205-DWETN32160",
        "variantId": "62036850180364",
        "quantity": 1
      },
      {
        "sku": "DWECO22160",
        "variantId": "62036929904908",
        "quantity": 2
      }
    ]
  },
  "62056703099148": {
    "candidateId": "DW-ECO-2-0-DN180-H10-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-eco-2-0",
    "dn": 180,
    "setSku": "JER-SET-DWECO20-7M-DN180-W100",
    "setPriceCents": 178250,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05180",
        "variantId": "62036841267468",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10180",
        "variantId": "62036844019980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11180",
        "variantId": "62036845265164",
        "quantity": 1
      },
      {
        "sku": "DWECO261180",
        "variantId": "62036934164748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13180",
        "variantId": "62036846051596",
        "quantity": 7
      },
      {
        "sku": "205-DWETN32180",
        "variantId": "62036850213132",
        "quantity": 1
      },
      {
        "sku": "DWECO22180",
        "variantId": "62036929937676",
        "quantity": 2
      }
    ]
  },
  "62056703131916": {
    "candidateId": "DW-ECO-2-0-DN200-H10-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-eco-2-0",
    "dn": 200,
    "setSku": "JER-SET-DWECO20-7M-DN200-W100",
    "setPriceCents": 197450,
    "bom": [
      {
        "sku": "DW392",
        "variantId": "62036905492748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05200",
        "variantId": "62036841300236",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10200",
        "variantId": "62036844052748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11200",
        "variantId": "62036845297932",
        "quantity": 1
      },
      {
        "sku": "DWECO261200",
        "variantId": "62036934197516",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13200",
        "variantId": "62036846084364",
        "quantity": 7
      },
      {
        "sku": "205-DWETN32200",
        "variantId": "62036850245900",
        "quantity": 1
      },
      {
        "sku": "DWECO22200",
        "variantId": "62036929970444",
        "quantity": 2
      }
    ]
  },
  "62056703164684": {
    "candidateId": "DW-BLACK-DN130-H10-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-black",
    "dn": 130,
    "setSku": "JER-SET-DWBLACK-7M-DN130-W100",
    "setPriceCents": 236840,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05130",
        "variantId": "62054703300876",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10130",
        "variantId": "62054704906508",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866130",
        "variantId": "62054705332492",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13130",
        "variantId": "62054705725708",
        "quantity": 7
      },
      {
        "sku": "16-DWECO22130",
        "variantId": "62054706675980",
        "quantity": 3
      },
      {
        "sku": "16-390-DWECO31130",
        "variantId": "62054707134732",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32130",
        "variantId": "62054707527948",
        "quantity": 1
      }
    ]
  },
  "62056703197452": {
    "candidateId": "DW-BLACK-DN150-H10-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-black",
    "dn": 150,
    "setSku": "JER-SET-DWBLACK-7M-DN150-W100",
    "setPriceCents": 259840,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05150",
        "variantId": "62054703333644",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10150",
        "variantId": "62054704939276",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866150",
        "variantId": "62054705365260",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13150",
        "variantId": "62054705758476",
        "quantity": 7
      },
      {
        "sku": "16-DWECO22150",
        "variantId": "62054706708748",
        "quantity": 3
      },
      {
        "sku": "16-390-DWECO31150",
        "variantId": "62054707167500",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32150",
        "variantId": "62054707560716",
        "quantity": 1
      }
    ]
  },
  "62056703230220": {
    "candidateId": "DW-BLACK-DN180-H10-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-black",
    "dn": 180,
    "setSku": "JER-SET-DWBLACK-7M-DN180-W100",
    "setPriceCents": 285840,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05180",
        "variantId": "62054703366412",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10180",
        "variantId": "62054704972044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866180",
        "variantId": "62054705398028",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13180",
        "variantId": "62054705791244",
        "quantity": 7
      },
      {
        "sku": "16-DWECO22180",
        "variantId": "62054706741516",
        "quantity": 3
      },
      {
        "sku": "16-390-DWECO31180",
        "variantId": "62054707200268",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32180",
        "variantId": "62054707593484",
        "quantity": 1
      }
    ]
  },
  "62056703262988": {
    "candidateId": "DW-BLACK-DN200-H10-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-black",
    "dn": 200,
    "setSku": "JER-SET-DWBLACK-7M-DN200-W100",
    "setPriceCents": 314940,
    "bom": [
      {
        "sku": "16-DW392",
        "variantId": "62055212876044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05200",
        "variantId": "62054703399180",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10200",
        "variantId": "62054705004812",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866200",
        "variantId": "62054705430796",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13200",
        "variantId": "62054705824012",
        "quantity": 7
      },
      {
        "sku": "16-DWECO22200",
        "variantId": "62054706774284",
        "quantity": 3
      },
      {
        "sku": "16-390-DWECO31200",
        "variantId": "62054707233036",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32200",
        "variantId": "62054707626252",
        "quantity": 1
      }
    ]
  },
  "62056703295756": {
    "candidateId": "DW-GREY-DN130-H10-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-grey",
    "dn": 130,
    "setSku": "JER-SET-DWGREY-7M-DN130-W100",
    "setPriceCents": 236840,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05130",
        "variantId": "62054703563020",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10130",
        "variantId": "62054705070348",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866130",
        "variantId": "62054705463564",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13130",
        "variantId": "62054705889548",
        "quantity": 7
      },
      {
        "sku": "28-DWECO22130",
        "variantId": "62054706872588",
        "quantity": 3
      },
      {
        "sku": "28-390-DWECO31130",
        "variantId": "62054707265804",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32130",
        "variantId": "62054707659020",
        "quantity": 1
      }
    ]
  },
  "62056703328524": {
    "candidateId": "DW-GREY-DN150-H10-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-grey",
    "dn": 150,
    "setSku": "JER-SET-DWGREY-7M-DN150-W100",
    "setPriceCents": 259840,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05150",
        "variantId": "62054703595788",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10150",
        "variantId": "62054705103116",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866150",
        "variantId": "62054705496332",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13150",
        "variantId": "62054705922316",
        "quantity": 7
      },
      {
        "sku": "28-DWECO22150",
        "variantId": "62054706905356",
        "quantity": 3
      },
      {
        "sku": "28-390-DWECO31150",
        "variantId": "62054707298572",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32150",
        "variantId": "62054707691788",
        "quantity": 1
      }
    ]
  },
  "62056703361292": {
    "candidateId": "DW-GREY-DN180-H10-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-grey",
    "dn": 180,
    "setSku": "JER-SET-DWGREY-7M-DN180-W100",
    "setPriceCents": 285840,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05180",
        "variantId": "62054703628556",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10180",
        "variantId": "62054705135884",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866180",
        "variantId": "62054705529100",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13180",
        "variantId": "62054705955084",
        "quantity": 7
      },
      {
        "sku": "28-DWECO22180",
        "variantId": "62054706938124",
        "quantity": 3
      },
      {
        "sku": "28-390-DWECO31180",
        "variantId": "62054707331340",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32180",
        "variantId": "62054707724556",
        "quantity": 1
      }
    ]
  },
  "62056703394060": {
    "candidateId": "DW-GREY-DN200-H10-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-grey",
    "dn": 200,
    "setSku": "JER-SET-DWGREY-7M-DN200-W100",
    "setPriceCents": 314940,
    "bom": [
      {
        "sku": "28-DW392",
        "variantId": "62055212908812",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05200",
        "variantId": "62054703661324",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10200",
        "variantId": "62054705168652",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866200",
        "variantId": "62054705561868",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13200",
        "variantId": "62054705987852",
        "quantity": 7
      },
      {
        "sku": "28-DWECO22200",
        "variantId": "62054706970892",
        "quantity": 3
      },
      {
        "sku": "28-390-DWECO31200",
        "variantId": "62054707364108",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32200",
        "variantId": "62054707757324",
        "quantity": 1
      }
    ]
  },
  "62056703426828": {
    "candidateId": "DW-WHITE-DN130-H10-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-white",
    "dn": 130,
    "setSku": "JER-SET-DWWHITE-7M-DN130-W100",
    "setPriceCents": 236840,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05130",
        "variantId": "62054704709900",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10130",
        "variantId": "62054705201420",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866130",
        "variantId": "62054705594636",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13130",
        "variantId": "62054706053388",
        "quantity": 7
      },
      {
        "sku": "47-DWECO22130",
        "variantId": "62054707003660",
        "quantity": 3
      },
      {
        "sku": "47-390-DWECO31130",
        "variantId": "62054707396876",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32130",
        "variantId": "62054707790092",
        "quantity": 1
      }
    ]
  },
  "62056703459596": {
    "candidateId": "DW-WHITE-DN150-H10-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-white",
    "dn": 150,
    "setSku": "JER-SET-DWWHITE-7M-DN150-W100",
    "setPriceCents": 259840,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05150",
        "variantId": "62054704742668",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10150",
        "variantId": "62054705234188",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866150",
        "variantId": "62054705627404",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13150",
        "variantId": "62054706086156",
        "quantity": 7
      },
      {
        "sku": "47-DWECO22150",
        "variantId": "62054707036428",
        "quantity": 3
      },
      {
        "sku": "47-390-DWECO31150",
        "variantId": "62054707429644",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32150",
        "variantId": "62054707822860",
        "quantity": 1
      }
    ]
  },
  "62056703492364": {
    "candidateId": "DW-WHITE-DN180-H10-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-white",
    "dn": 180,
    "setSku": "JER-SET-DWWHITE-7M-DN180-W100",
    "setPriceCents": 285840,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05180",
        "variantId": "62054704775436",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10180",
        "variantId": "62054705266956",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866180",
        "variantId": "62054705660172",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13180",
        "variantId": "62054706118924",
        "quantity": 7
      },
      {
        "sku": "47-DWECO22180",
        "variantId": "62054707069196",
        "quantity": 3
      },
      {
        "sku": "47-390-DWECO31180",
        "variantId": "62054707462412",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32180",
        "variantId": "62054707855628",
        "quantity": 1
      }
    ]
  },
  "62056703525132": {
    "candidateId": "DW-WHITE-DN200-H10-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 7 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-7m-jeremias-dw-white",
    "dn": 200,
    "setSku": "JER-SET-DWWHITE-7M-DN200-W100",
    "setPriceCents": 314940,
    "bom": [
      {
        "sku": "47-DW392",
        "variantId": "62055212941580",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05200",
        "variantId": "62054704808204",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10200",
        "variantId": "62054705299724",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866200",
        "variantId": "62054705692940",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13200",
        "variantId": "62054706151692",
        "quantity": 7
      },
      {
        "sku": "47-DWECO22200",
        "variantId": "62054707101964",
        "quantity": 3
      },
      {
        "sku": "47-390-DWECO31200",
        "variantId": "62054707495180",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32200",
        "variantId": "62054707888396",
        "quantity": 1
      }
    ]
  },
  "62056712798476": {
    "candidateId": "DW-FU-DN130-H5041-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-fu",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 124980,
    "bom": [
      {
        "sku": "DW05130",
        "variantId": "62036863156492",
        "quantity": 1
      },
      {
        "sku": "DW10130",
        "variantId": "62036868530444",
        "quantity": 1
      },
      {
        "sku": "DW317130",
        "variantId": "62036894581004",
        "quantity": 1
      },
      {
        "sku": "DW32130",
        "variantId": "62036895629580",
        "quantity": 1
      },
      {
        "sku": "DW31130",
        "variantId": "62036895105292",
        "quantity": 1
      },
      {
        "sku": "DW13130",
        "variantId": "62036871053580",
        "quantity": 4
      },
      {
        "sku": "DW22130",
        "variantId": "62036880064780",
        "quantity": 2
      },
      {
        "sku": "DW01130",
        "variantId": "62036861059340",
        "quantity": 1
      }
    ]
  },
  "62056712831244": {
    "candidateId": "DW-FU-DN150-H5041-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-fu",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 135920,
    "bom": [
      {
        "sku": "DW-JGP01150",
        "variantId": "62047284265228",
        "quantity": 1
      },
      {
        "sku": "DW13150",
        "variantId": "62036871086348",
        "quantity": 4
      },
      {
        "sku": "DW22150",
        "variantId": "62036880097548",
        "quantity": 2
      },
      {
        "sku": "DW01150",
        "variantId": "62036861092108",
        "quantity": 1
      }
    ]
  },
  "62056712864012": {
    "candidateId": "DW-FU-DN180-H5041-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-fu",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 151680,
    "bom": [
      {
        "sku": "DW05180",
        "variantId": "62036863254796",
        "quantity": 1
      },
      {
        "sku": "DW10180",
        "variantId": "62036868628748",
        "quantity": 1
      },
      {
        "sku": "DW317180",
        "variantId": "62036894679308",
        "quantity": 1
      },
      {
        "sku": "DW32180",
        "variantId": "62036895727884",
        "quantity": 1
      },
      {
        "sku": "DW31180",
        "variantId": "62036895203596",
        "quantity": 1
      },
      {
        "sku": "DW13180",
        "variantId": "62036871151884",
        "quantity": 4
      },
      {
        "sku": "DW22180",
        "variantId": "62036880163084",
        "quantity": 2
      },
      {
        "sku": "DW01180",
        "variantId": "62036861157644",
        "quantity": 1
      }
    ]
  },
  "62056712896780": {
    "candidateId": "DW-FU-DN200-H5041-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-fu",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 171080,
    "bom": [
      {
        "sku": "DW05200",
        "variantId": "62036863287564",
        "quantity": 1
      },
      {
        "sku": "DW10200",
        "variantId": "62036868661516",
        "quantity": 1
      },
      {
        "sku": "DW317200",
        "variantId": "62036894712076",
        "quantity": 1
      },
      {
        "sku": "DW32200",
        "variantId": "62036895760652",
        "quantity": 1
      },
      {
        "sku": "DW31200",
        "variantId": "62036895236364",
        "quantity": 1
      },
      {
        "sku": "DW13200",
        "variantId": "62036871184652",
        "quantity": 4
      },
      {
        "sku": "DW22200",
        "variantId": "62036880195852",
        "quantity": 2
      },
      {
        "sku": "DW01200",
        "variantId": "62036861190412",
        "quantity": 1
      }
    ]
  },
  "62056712929548": {
    "candidateId": "DW-ECO-2-0-DN130-H8-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-eco-2-0",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 127470,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05130",
        "variantId": "62036841169164",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10130",
        "variantId": "62036843921676",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11130",
        "variantId": "62036845166860",
        "quantity": 1
      },
      {
        "sku": "DWECO261130",
        "variantId": "62036934066444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13130",
        "variantId": "62036845953292",
        "quantity": 5
      },
      {
        "sku": "205-DWETN32130",
        "variantId": "62036850114828",
        "quantity": 1
      },
      {
        "sku": "DWECO22130",
        "variantId": "62036929839372",
        "quantity": 2
      }
    ]
  },
  "62056712962316": {
    "candidateId": "DW-ECO-2-0-DN150-H8-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-eco-2-0",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 137470,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05150",
        "variantId": "62036841201932",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10150",
        "variantId": "62036843954444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11150",
        "variantId": "62036845199628",
        "quantity": 1
      },
      {
        "sku": "DWECO261150",
        "variantId": "62036934099212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13150",
        "variantId": "62036845986060",
        "quantity": 5
      },
      {
        "sku": "205-DWETN32150",
        "variantId": "62036850147596",
        "quantity": 1
      },
      {
        "sku": "DWECO22150",
        "variantId": "62036929872140",
        "quantity": 2
      }
    ]
  },
  "62056712995084": {
    "candidateId": "DW-ECO-2-0-DN160-H8-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-eco-2-0",
    "dn": 160,
    "setSku": null,
    "setPriceCents": 144570,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05160",
        "variantId": "62036841234700",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10160",
        "variantId": "62036843987212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11160",
        "variantId": "62036845232396",
        "quantity": 1
      },
      {
        "sku": "DWECO261160",
        "variantId": "62036934131980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13160",
        "variantId": "62036846018828",
        "quantity": 5
      },
      {
        "sku": "205-DWETN32160",
        "variantId": "62036850180364",
        "quantity": 1
      },
      {
        "sku": "DWECO22160",
        "variantId": "62036929904908",
        "quantity": 2
      }
    ]
  },
  "62056713027852": {
    "candidateId": "DW-ECO-2-0-DN180-H8-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-eco-2-0",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 151270,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05180",
        "variantId": "62036841267468",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10180",
        "variantId": "62036844019980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11180",
        "variantId": "62036845265164",
        "quantity": 1
      },
      {
        "sku": "DWECO261180",
        "variantId": "62036934164748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13180",
        "variantId": "62036846051596",
        "quantity": 5
      },
      {
        "sku": "205-DWETN32180",
        "variantId": "62036850213132",
        "quantity": 1
      },
      {
        "sku": "DWECO22180",
        "variantId": "62036929937676",
        "quantity": 2
      }
    ]
  },
  "62056713060620": {
    "candidateId": "DW-ECO-2-0-DN200-H8-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-eco-2-0",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 167670,
    "bom": [
      {
        "sku": "DW392",
        "variantId": "62036905492748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05200",
        "variantId": "62036841300236",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10200",
        "variantId": "62036844052748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11200",
        "variantId": "62036845297932",
        "quantity": 1
      },
      {
        "sku": "DWECO261200",
        "variantId": "62036934197516",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13200",
        "variantId": "62036846084364",
        "quantity": 5
      },
      {
        "sku": "205-DWETN32200",
        "variantId": "62036850245900",
        "quantity": 1
      },
      {
        "sku": "DWECO22200",
        "variantId": "62036929970444",
        "quantity": 2
      }
    ]
  },
  "62056713093388": {
    "candidateId": "DW-BLACK-DN130-H8-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-black",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 193170,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05130",
        "variantId": "62054703300876",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10130",
        "variantId": "62054704906508",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866130",
        "variantId": "62054705332492",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13130",
        "variantId": "62054705725708",
        "quantity": 5
      },
      {
        "sku": "16-DWECO22130",
        "variantId": "62054706675980",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31130",
        "variantId": "62054707134732",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32130",
        "variantId": "62054707527948",
        "quantity": 1
      }
    ]
  },
  "62056713126156": {
    "candidateId": "DW-BLACK-DN150-H8-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-black",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 211370,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05150",
        "variantId": "62054703333644",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10150",
        "variantId": "62054704939276",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866150",
        "variantId": "62054705365260",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13150",
        "variantId": "62054705758476",
        "quantity": 5
      },
      {
        "sku": "16-DWECO22150",
        "variantId": "62054706708748",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31150",
        "variantId": "62054707167500",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32150",
        "variantId": "62054707560716",
        "quantity": 1
      }
    ]
  },
  "62056713158924": {
    "candidateId": "DW-BLACK-DN180-H8-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-black",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 231470,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05180",
        "variantId": "62054703366412",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10180",
        "variantId": "62054704972044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866180",
        "variantId": "62054705398028",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13180",
        "variantId": "62054705791244",
        "quantity": 5
      },
      {
        "sku": "16-DWECO22180",
        "variantId": "62054706741516",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31180",
        "variantId": "62054707200268",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32180",
        "variantId": "62054707593484",
        "quantity": 1
      }
    ]
  },
  "62056713191692": {
    "candidateId": "DW-BLACK-DN200-H8-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-black",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 255370,
    "bom": [
      {
        "sku": "16-DW392",
        "variantId": "62055212876044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05200",
        "variantId": "62054703399180",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10200",
        "variantId": "62054705004812",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866200",
        "variantId": "62054705430796",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13200",
        "variantId": "62054705824012",
        "quantity": 5
      },
      {
        "sku": "16-DWECO22200",
        "variantId": "62054706774284",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31200",
        "variantId": "62054707233036",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32200",
        "variantId": "62054707626252",
        "quantity": 1
      }
    ]
  },
  "62056713224460": {
    "candidateId": "DW-GREY-DN130-H8-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-grey",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 193170,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05130",
        "variantId": "62054703563020",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10130",
        "variantId": "62054705070348",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866130",
        "variantId": "62054705463564",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13130",
        "variantId": "62054705889548",
        "quantity": 5
      },
      {
        "sku": "28-DWECO22130",
        "variantId": "62054706872588",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31130",
        "variantId": "62054707265804",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32130",
        "variantId": "62054707659020",
        "quantity": 1
      }
    ]
  },
  "62056713257228": {
    "candidateId": "DW-GREY-DN150-H8-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-grey",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 211370,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05150",
        "variantId": "62054703595788",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10150",
        "variantId": "62054705103116",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866150",
        "variantId": "62054705496332",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13150",
        "variantId": "62054705922316",
        "quantity": 5
      },
      {
        "sku": "28-DWECO22150",
        "variantId": "62054706905356",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31150",
        "variantId": "62054707298572",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32150",
        "variantId": "62054707691788",
        "quantity": 1
      }
    ]
  },
  "62056713289996": {
    "candidateId": "DW-GREY-DN180-H8-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-grey",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 231470,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05180",
        "variantId": "62054703628556",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10180",
        "variantId": "62054705135884",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866180",
        "variantId": "62054705529100",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13180",
        "variantId": "62054705955084",
        "quantity": 5
      },
      {
        "sku": "28-DWECO22180",
        "variantId": "62054706938124",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31180",
        "variantId": "62054707331340",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32180",
        "variantId": "62054707724556",
        "quantity": 1
      }
    ]
  },
  "62056713322764": {
    "candidateId": "DW-GREY-DN200-H8-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-grey",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 255370,
    "bom": [
      {
        "sku": "28-DW392",
        "variantId": "62055212908812",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05200",
        "variantId": "62054703661324",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10200",
        "variantId": "62054705168652",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866200",
        "variantId": "62054705561868",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13200",
        "variantId": "62054705987852",
        "quantity": 5
      },
      {
        "sku": "28-DWECO22200",
        "variantId": "62054706970892",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31200",
        "variantId": "62054707364108",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32200",
        "variantId": "62054707757324",
        "quantity": 1
      }
    ]
  },
  "62056713355532": {
    "candidateId": "DW-WHITE-DN130-H8-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-white",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 193170,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05130",
        "variantId": "62054704709900",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10130",
        "variantId": "62054705201420",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866130",
        "variantId": "62054705594636",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13130",
        "variantId": "62054706053388",
        "quantity": 5
      },
      {
        "sku": "47-DWECO22130",
        "variantId": "62054707003660",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31130",
        "variantId": "62054707396876",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32130",
        "variantId": "62054707790092",
        "quantity": 1
      }
    ]
  },
  "62056713388300": {
    "candidateId": "DW-WHITE-DN150-H8-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-white",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 211370,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05150",
        "variantId": "62054704742668",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10150",
        "variantId": "62054705234188",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866150",
        "variantId": "62054705627404",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13150",
        "variantId": "62054706086156",
        "quantity": 5
      },
      {
        "sku": "47-DWECO22150",
        "variantId": "62054707036428",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31150",
        "variantId": "62054707429644",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32150",
        "variantId": "62054707822860",
        "quantity": 1
      }
    ]
  },
  "62056713421068": {
    "candidateId": "DW-WHITE-DN180-H8-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-white",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 231470,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05180",
        "variantId": "62054704775436",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10180",
        "variantId": "62054705266956",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866180",
        "variantId": "62054705660172",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13180",
        "variantId": "62054706118924",
        "quantity": 5
      },
      {
        "sku": "47-DWECO22180",
        "variantId": "62054707069196",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31180",
        "variantId": "62054707462412",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32180",
        "variantId": "62054707855628",
        "quantity": 1
      }
    ]
  },
  "62056713453836": {
    "candidateId": "DW-WHITE-DN200-H8-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 5 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-5m-jeremias-dw-white",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 255370,
    "bom": [
      {
        "sku": "47-DW392",
        "variantId": "62055212941580",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05200",
        "variantId": "62054704808204",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10200",
        "variantId": "62054705299724",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866200",
        "variantId": "62054705692940",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13200",
        "variantId": "62054706151692",
        "quantity": 5
      },
      {
        "sku": "47-DWECO22200",
        "variantId": "62054707101964",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31200",
        "variantId": "62054707495180",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32200",
        "variantId": "62054707888396",
        "quantity": 1
      }
    ]
  },
  "62057883435276": {
    "candidateId": "DW-FU-DN130-H4097-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-fu",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 112390,
    "bom": [
      {
        "sku": "DW05130",
        "variantId": "62036863156492",
        "quantity": 1
      },
      {
        "sku": "DW10130",
        "variantId": "62036868530444",
        "quantity": 1
      },
      {
        "sku": "DW317130",
        "variantId": "62036894581004",
        "quantity": 1
      },
      {
        "sku": "DW32130",
        "variantId": "62036895629580",
        "quantity": 1
      },
      {
        "sku": "DW31130",
        "variantId": "62036895105292",
        "quantity": 1
      },
      {
        "sku": "DW13130",
        "variantId": "62036871053580",
        "quantity": 3
      },
      {
        "sku": "DW22130",
        "variantId": "62036880064780",
        "quantity": 2
      },
      {
        "sku": "DW01130",
        "variantId": "62036861059340",
        "quantity": 1
      }
    ]
  },
  "62057883468044": {
    "candidateId": "DW-FU-DN150-H4097-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-fu",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 121830,
    "bom": [
      {
        "sku": "DW-JGP01150",
        "variantId": "62047284265228",
        "quantity": 1
      },
      {
        "sku": "DW13150",
        "variantId": "62036871086348",
        "quantity": 3
      },
      {
        "sku": "DW22150",
        "variantId": "62036880097548",
        "quantity": 2
      },
      {
        "sku": "DW01150",
        "variantId": "62036861092108",
        "quantity": 1
      }
    ]
  },
  "62057883500812": {
    "candidateId": "DW-FU-DN180-H4097-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-fu",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 135790,
    "bom": [
      {
        "sku": "DW05180",
        "variantId": "62036863254796",
        "quantity": 1
      },
      {
        "sku": "DW10180",
        "variantId": "62036868628748",
        "quantity": 1
      },
      {
        "sku": "DW317180",
        "variantId": "62036894679308",
        "quantity": 1
      },
      {
        "sku": "DW32180",
        "variantId": "62036895727884",
        "quantity": 1
      },
      {
        "sku": "DW31180",
        "variantId": "62036895203596",
        "quantity": 1
      },
      {
        "sku": "DW13180",
        "variantId": "62036871151884",
        "quantity": 3
      },
      {
        "sku": "DW22180",
        "variantId": "62036880163084",
        "quantity": 2
      },
      {
        "sku": "DW01180",
        "variantId": "62036861157644",
        "quantity": 1
      }
    ]
  },
  "62057883533580": {
    "candidateId": "DW-FU-DN200-H4097-W100",
    "system": "DW-FU",
    "systemKey": "dw-fu",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-FU",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-fu",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 153390,
    "bom": [
      {
        "sku": "DW05200",
        "variantId": "62036863287564",
        "quantity": 1
      },
      {
        "sku": "DW10200",
        "variantId": "62036868661516",
        "quantity": 1
      },
      {
        "sku": "DW317200",
        "variantId": "62036894712076",
        "quantity": 1
      },
      {
        "sku": "DW32200",
        "variantId": "62036895760652",
        "quantity": 1
      },
      {
        "sku": "DW31200",
        "variantId": "62036895236364",
        "quantity": 1
      },
      {
        "sku": "DW13200",
        "variantId": "62036871184652",
        "quantity": 3
      },
      {
        "sku": "DW22200",
        "variantId": "62036880195852",
        "quantity": 2
      },
      {
        "sku": "DW01200",
        "variantId": "62036861190412",
        "quantity": 1
      }
    ]
  },
  "62057883566348": {
    "candidateId": "DW-ECO-2-0-DN130-H7-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-eco-2-0",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 116980,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05130",
        "variantId": "62036841169164",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10130",
        "variantId": "62036843921676",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11130",
        "variantId": "62036845166860",
        "quantity": 1
      },
      {
        "sku": "DWECO261130",
        "variantId": "62036934066444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13130",
        "variantId": "62036845953292",
        "quantity": 4
      },
      {
        "sku": "205-DWETN32130",
        "variantId": "62036850114828",
        "quantity": 1
      },
      {
        "sku": "DWECO22130",
        "variantId": "62036929839372",
        "quantity": 2
      }
    ]
  },
  "62057883599116": {
    "candidateId": "DW-ECO-2-0-DN150-H7-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-eco-2-0",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 125780,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05150",
        "variantId": "62036841201932",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10150",
        "variantId": "62036843954444",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11150",
        "variantId": "62036845199628",
        "quantity": 1
      },
      {
        "sku": "DWECO261150",
        "variantId": "62036934099212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13150",
        "variantId": "62036845986060",
        "quantity": 4
      },
      {
        "sku": "205-DWETN32150",
        "variantId": "62036850147596",
        "quantity": 1
      },
      {
        "sku": "DWECO22150",
        "variantId": "62036929872140",
        "quantity": 2
      }
    ]
  },
  "62057883631884": {
    "candidateId": "DW-ECO-2-0-DN160-H7-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-eco-2-0",
    "dn": 160,
    "setSku": null,
    "setPriceCents": 131980,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05160",
        "variantId": "62036841234700",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10160",
        "variantId": "62036843987212",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11160",
        "variantId": "62036845232396",
        "quantity": 1
      },
      {
        "sku": "DWECO261160",
        "variantId": "62036934131980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13160",
        "variantId": "62036846018828",
        "quantity": 4
      },
      {
        "sku": "205-DWETN32160",
        "variantId": "62036850180364",
        "quantity": 1
      },
      {
        "sku": "DWECO22160",
        "variantId": "62036929904908",
        "quantity": 2
      }
    ]
  },
  "62057883664652": {
    "candidateId": "DW-ECO-2-0-DN180-H7-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-eco-2-0",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 137780,
    "bom": [
      {
        "sku": "DW391",
        "variantId": "62036905459980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05180",
        "variantId": "62036841267468",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10180",
        "variantId": "62036844019980",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11180",
        "variantId": "62036845265164",
        "quantity": 1
      },
      {
        "sku": "DWECO261180",
        "variantId": "62036934164748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13180",
        "variantId": "62036846051596",
        "quantity": 4
      },
      {
        "sku": "205-DWETN32180",
        "variantId": "62036850213132",
        "quantity": 1
      },
      {
        "sku": "DWECO22180",
        "variantId": "62036929937676",
        "quantity": 2
      }
    ]
  },
  "62057883697420": {
    "candidateId": "DW-ECO-2-0-DN200-H7-W100",
    "system": "DW-ECO 2.0",
    "systemKey": "dw-eco-20",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-ECO 2.0",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-eco-2-0",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 152780,
    "bom": [
      {
        "sku": "DW392",
        "variantId": "62036905492748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN05200",
        "variantId": "62036841300236",
        "quantity": 1
      },
      {
        "sku": "205-DWETN10200",
        "variantId": "62036844052748",
        "quantity": 1
      },
      {
        "sku": "205-DWETN11200",
        "variantId": "62036845297932",
        "quantity": 1
      },
      {
        "sku": "DWECO261200",
        "variantId": "62036934197516",
        "quantity": 1
      },
      {
        "sku": "205-DWETN13200",
        "variantId": "62036846084364",
        "quantity": 4
      },
      {
        "sku": "205-DWETN32200",
        "variantId": "62036850245900",
        "quantity": 1
      },
      {
        "sku": "DWECO22200",
        "variantId": "62036929970444",
        "quantity": 2
      }
    ]
  },
  "62057883730188": {
    "candidateId": "DW-BLACK-DN130-H7-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-black",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 176080,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05130",
        "variantId": "62054703300876",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10130",
        "variantId": "62054704906508",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866130",
        "variantId": "62054705332492",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13130",
        "variantId": "62054705725708",
        "quantity": 4
      },
      {
        "sku": "16-DWECO22130",
        "variantId": "62054706675980",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31130",
        "variantId": "62054707134732",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32130",
        "variantId": "62054707527948",
        "quantity": 1
      }
    ]
  },
  "62057883762956": {
    "candidateId": "DW-BLACK-DN150-H7-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-black",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 191980,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05150",
        "variantId": "62054703333644",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10150",
        "variantId": "62054704939276",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866150",
        "variantId": "62054705365260",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13150",
        "variantId": "62054705758476",
        "quantity": 4
      },
      {
        "sku": "16-DWECO22150",
        "variantId": "62054706708748",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31150",
        "variantId": "62054707167500",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32150",
        "variantId": "62054707560716",
        "quantity": 1
      }
    ]
  },
  "62057883795724": {
    "candidateId": "DW-BLACK-DN180-H7-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-black",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 209280,
    "bom": [
      {
        "sku": "16-DW391",
        "variantId": "62054702153996",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05180",
        "variantId": "62054703366412",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10180",
        "variantId": "62054704972044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866180",
        "variantId": "62054705398028",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13180",
        "variantId": "62054705791244",
        "quantity": 4
      },
      {
        "sku": "16-DWECO22180",
        "variantId": "62054706741516",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31180",
        "variantId": "62054707200268",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32180",
        "variantId": "62054707593484",
        "quantity": 1
      }
    ]
  },
  "62057883828492": {
    "candidateId": "DW-BLACK-DN200-H7-W100",
    "system": "DW-BLACK",
    "systemKey": "dw-black",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-BLACK",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-black",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 230680,
    "bom": [
      {
        "sku": "16-DW392",
        "variantId": "62055212876044",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN05200",
        "variantId": "62054703399180",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN10200",
        "variantId": "62054705004812",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN2866200",
        "variantId": "62054705430796",
        "quantity": 1
      },
      {
        "sku": "16-290-DWETN13200",
        "variantId": "62054705824012",
        "quantity": 4
      },
      {
        "sku": "16-DWECO22200",
        "variantId": "62054706774284",
        "quantity": 2
      },
      {
        "sku": "16-390-DWECO31200",
        "variantId": "62054707233036",
        "quantity": 1
      },
      {
        "sku": "16-205-DWETN32200",
        "variantId": "62054707626252",
        "quantity": 1
      }
    ]
  },
  "62057883861260": {
    "candidateId": "DW-GREY-DN130-H7-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-grey",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 176080,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05130",
        "variantId": "62054703563020",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10130",
        "variantId": "62054705070348",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866130",
        "variantId": "62054705463564",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13130",
        "variantId": "62054705889548",
        "quantity": 4
      },
      {
        "sku": "28-DWECO22130",
        "variantId": "62054706872588",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31130",
        "variantId": "62054707265804",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32130",
        "variantId": "62054707659020",
        "quantity": 1
      }
    ]
  },
  "62057883894028": {
    "candidateId": "DW-GREY-DN150-H7-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-grey",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 191980,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05150",
        "variantId": "62054703595788",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10150",
        "variantId": "62054705103116",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866150",
        "variantId": "62054705496332",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13150",
        "variantId": "62054705922316",
        "quantity": 4
      },
      {
        "sku": "28-DWECO22150",
        "variantId": "62054706905356",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31150",
        "variantId": "62054707298572",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32150",
        "variantId": "62054707691788",
        "quantity": 1
      }
    ]
  },
  "62057883926796": {
    "candidateId": "DW-GREY-DN180-H7-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-grey",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 209280,
    "bom": [
      {
        "sku": "28-DW391",
        "variantId": "62054703235340",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05180",
        "variantId": "62054703628556",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10180",
        "variantId": "62054705135884",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866180",
        "variantId": "62054705529100",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13180",
        "variantId": "62054705955084",
        "quantity": 4
      },
      {
        "sku": "28-DWECO22180",
        "variantId": "62054706938124",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31180",
        "variantId": "62054707331340",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32180",
        "variantId": "62054707724556",
        "quantity": 1
      }
    ]
  },
  "62057883959564": {
    "candidateId": "DW-GREY-DN200-H7-W100",
    "system": "DW-GREY",
    "systemKey": "dw-grey",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-GREY",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-grey",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 230680,
    "bom": [
      {
        "sku": "28-DW392",
        "variantId": "62055212908812",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN05200",
        "variantId": "62054703661324",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN10200",
        "variantId": "62054705168652",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN2866200",
        "variantId": "62054705561868",
        "quantity": 1
      },
      {
        "sku": "28-290-DWETN13200",
        "variantId": "62054705987852",
        "quantity": 4
      },
      {
        "sku": "28-DWECO22200",
        "variantId": "62054706970892",
        "quantity": 2
      },
      {
        "sku": "28-390-DWECO31200",
        "variantId": "62054707364108",
        "quantity": 1
      },
      {
        "sku": "28-205-DWETN32200",
        "variantId": "62054707757324",
        "quantity": 1
      }
    ]
  },
  "62057884123404": {
    "candidateId": "DW-WHITE-DN130-H7-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-white",
    "dn": 130,
    "setSku": null,
    "setPriceCents": 176080,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05130",
        "variantId": "62054704709900",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10130",
        "variantId": "62054705201420",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866130",
        "variantId": "62054705594636",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13130",
        "variantId": "62054706053388",
        "quantity": 4
      },
      {
        "sku": "47-DWECO22130",
        "variantId": "62054707003660",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31130",
        "variantId": "62054707396876",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32130",
        "variantId": "62054707790092",
        "quantity": 1
      }
    ]
  },
  "62057884156172": {
    "candidateId": "DW-WHITE-DN150-H7-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-white",
    "dn": 150,
    "setSku": null,
    "setPriceCents": 191980,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05150",
        "variantId": "62054704742668",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10150",
        "variantId": "62054705234188",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866150",
        "variantId": "62054705627404",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13150",
        "variantId": "62054706086156",
        "quantity": 4
      },
      {
        "sku": "47-DWECO22150",
        "variantId": "62054707036428",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31150",
        "variantId": "62054707429644",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32150",
        "variantId": "62054707822860",
        "quantity": 1
      }
    ]
  },
  "62057884188940": {
    "candidateId": "DW-WHITE-DN180-H7-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-white",
    "dn": 180,
    "setSku": null,
    "setPriceCents": 209280,
    "bom": [
      {
        "sku": "47-DW391",
        "variantId": "62054703268108",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05180",
        "variantId": "62054704775436",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10180",
        "variantId": "62054705266956",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866180",
        "variantId": "62054705660172",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13180",
        "variantId": "62054706118924",
        "quantity": 4
      },
      {
        "sku": "47-DWECO22180",
        "variantId": "62054707069196",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31180",
        "variantId": "62054707462412",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32180",
        "variantId": "62054707855628",
        "quantity": 1
      }
    ]
  },
  "62057884221708": {
    "candidateId": "DW-WHITE-DN200-H7-W100",
    "system": "DW-WHITE",
    "systemKey": "dw-white",
    "title": "Edelstahlschornstein-Bausatz 4 m – Jeremias DW-WHITE",
    "handle": "edelstahlschornstein-bausatz-4m-jeremias-dw-white",
    "dn": 200,
    "setSku": null,
    "setPriceCents": 230680,
    "bom": [
      {
        "sku": "47-DW392",
        "variantId": "62055212941580",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN05200",
        "variantId": "62054704808204",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN10200",
        "variantId": "62054705299724",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN2866200",
        "variantId": "62054705692940",
        "quantity": 1
      },
      {
        "sku": "47-290-DWETN13200",
        "variantId": "62054706151692",
        "quantity": 4
      },
      {
        "sku": "47-DWECO22200",
        "variantId": "62054707101964",
        "quantity": 2
      },
      {
        "sku": "47-390-DWECO31200",
        "variantId": "62054707495180",
        "quantity": 1
      },
      {
        "sku": "47-205-DWETN32200",
        "variantId": "62054707888396",
        "quantity": 1
      }
    ]
  }
});

  function getSpecification(variantId) {
    return specifications[String(variantId)] || null;
  }

  function createGroupId(specification) {
    const random = Math.random().toString(36).slice(2, 9);
    return `jeremias-set-${specification.systemKey}-dn${specification.dn}-${Date.now().toString(36)}-${random}`;
  }

  function buildPayload(variantId, requestedQuantity = 1, groupId) {
    const specification = getSpecification(variantId);
    if (!specification) throw new Error('SET_VARIANT_BOM_MAPPING_MISSING');
    const quantity = Number.parseInt(requestedQuantity, 10);
    if (!Number.isInteger(quantity) || quantity < 1) throw new Error('SET_QUANTITY_INVALID');
    const resolvedGroupId = groupId || createGroupId(specification);
    return {
      items: specification.bom.map((line) => ({
        id: Number(line.variantId),
        quantity: line.quantity * quantity,
        properties: {
          'Set': specification.title,
          'Set-DN': `DN ${specification.dn}`,
          '_Set-Gruppen-ID': resolvedGroupId,
          ...(specification.setSku ? { '_Set-SKU': specification.setSku } : {}),
          '_Jeremias-SKU': line.sku
        }
      }))
    };
  }

  const api = Object.freeze({ specifications, getSpecification, buildPayload });
  root.JeremiasSetToBomCart = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document) return;

  function setLoading(form, loading) {
    form.dataset.jeremiasSetBomSubmitting = loading ? 'true' : 'false';
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    button.toggleAttribute('disabled', loading);
    button.setAttribute('aria-disabled', loading ? 'true' : 'false');
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
  }

  root.document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-form')) return;
    const formData = new FormData(form);
    const variantId = String(formData.get('id') || '');
    const specification = getSpecification(variantId);
    if (!specification) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.jeremiasSetBomSubmitting === 'true') return;
    setLoading(form, true);

    try {
      const payload = buildPayload(variantId, formData.get('quantity') || 1);
      const rootPath = root.Shopify?.routes?.root || '/';
      const response = await fetch(root.routes?.cart_add_url || `${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok || body.status) throw new Error(body.description || body.message || 'Das Set konnte nicht in den Warenkorb gelegt werden.');
      root.document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'jeremias-set-to-bom-cart' } }));
      root.location.assign(root.routes?.cart_url || `${rootPath}cart`);
    } catch (error) {
      setLoading(form, false);
      const message = error?.message || 'Das Set konnte nicht in den Warenkorb gelegt werden.';
      form.closest('product-form')?.handleErrorMessage?.(message);
      root.document.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { source: 'jeremias-set-to-bom-cart', message } }));
    }
  }, true);
})(typeof window !== 'undefined' ? window : globalThis);
